import { render, staticRenderFns } from "./cpt-dataV-scrollList.vue?vue&type=template&id=7819c09c&scoped=true&"
import script from "./cpt-dataV-scrollList.vue?vue&type=script&lang=js&"
export * from "./cpt-dataV-scrollList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7819c09c",
  null
  
)

export default component.exports